import { List, Skeleton, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import FormHeader from "components/ui/atoms/FormHeader";
import Highlight from "components/ui/atoms/Highlight";
import DealSnapshotListItem from "models/committee/DealSnapshotListItem";
import { useDealSnapshotsFromCompany } from "models/companies/apiCompany";
import { useNavigate } from "react-router-dom";

const SnapshotList = ({ companyId, onClose }) => {
  const {
    data: dealSnapshots,
    isLoading,
    isError,
  } = useDealSnapshotsFromCompany(companyId);
  const theme = useTheme();
  const navigate = useNavigate();

  if (isLoading)
    return (
      <Grid container spacing={2} p={1}>
        <Grid size={12}>
          <Skeleton variant="rectangular" height={250} />
        </Grid>
        <Grid xs={12}>
          <Skeleton variant="rectangular" height={250} />
        </Grid>
        <Grid xs={12}>
          <Skeleton variant="rectangular" height={250} />
        </Grid>
        <Grid size={12}>
          <Skeleton variant="rectangular" height={250} />
        </Grid>
        <Grid size={12}>
          <Skeleton variant="rectangular" height={250} />
        </Grid>
      </Grid>
    );
  if (isError) return <>Error</>;

  return (
    <>
      <FormHeader onClose={onClose}>
        <Highlight color={theme.palette_custom.yellow}>Deal history</Highlight>
      </FormHeader>
      <List sx={{ pt: 8 }}>
        {dealSnapshots.map((history, index) => {
          return (
            <DealSnapshotListItem
              key={index}
              snapshot={history}
              onClick={() =>
                navigate(`/committee_minute/${history.committee_minute_id}`)
              }
            />
          );
        })}
      </List>
    </>
  );
};

export default SnapshotList;
